import CardFastRamadhan from './CardFastRamadhan';

export default CardFastRamadhan;
